"use strict";

require("./_values-icon");